import { Divider, Grid, List, ListItem, ListItemText, Box, Button } from "@mui/material";
import {ExpandMore, ExpandLess} from '@mui/icons-material';
import React, { useMemo, useState } from "react";

const formatDate = (date) => {
    const options = { hour: '2-digit', minute: '2-digit' };
    return new Date(date).toLocaleTimeString([], options);
};

const SportEventList = ({ events, selectedSport }) => {
  
  const getPrimary = (event) => {

    if(event.phase?.competitionDiscipline?.discipline?.label === event.phase?.competitionDiscipline?.discipline?.sport?.label){
      return `${event.phase?.competitionDiscipline?.discipline?.sport?.label}`
    }

    let primary = `${!selectedSport ? `${event.phase?.competitionDiscipline?.discipline?.sport?.label} (${event.phase?.competitionDiscipline?.discipline?.label})` : `${event.phase?.competitionDiscipline?.discipline?.label}`}`
  
    return primary
  }

  const getSecondary = (event) => {

    if(event.phase?.epreuve?.name === event.phase?.name){
      return `${event.phase?.category?.name} - ${event.phase?.name}`
    }

    let secondary = `${event.phase?.category?.name} - ${event.phase?.epreuve?.name} - ${event.phase?.name}`
  
    return secondary
  }


  return (
    <Box style={{ maxWidth: 600, margin: 'auto'}}>
      <List>
        <Divider />
        {events.map((event, index) => (
          <React.Fragment key={event._id}>
            <ListItem sx={{ display: 'flex', padding: 2 }}>
              <Grid container wrap="nowrap" spacing={2}>
                <Grid item xs={2}>
                  <ListItemText
                    primary={formatDate(event.date)}
                    primaryTypographyProps={{
                      fontSize: '1.15rem',
                      fontWeight : 'bold',
                      color : '#47464B'
                    }}
                  >

                  </ListItemText>
                </Grid>
                <Grid item xs={10}>
                  <ListItemText
                    sx={{marginTop : '3px'}}
                    primary={getPrimary(event)}
                    secondary={getSecondary(event)}
                    primaryTypographyProps={{
                      fontSize: '1.15rem',
                      fontWeight : 'bold',
                      color : '#47464B',
                    }}
                    secondaryTypographyProps={{
                      fontSize: '1rem',
                      color : '#47464B',
                    }}
                  />

                    <Actors event={event} />  
                </Grid>
              </Grid>
            </ListItem>

            
            <Divider />
          </React.Fragment>
        ))}
      </List>
    </Box>
  );
};

const Actors = ({event}) => {

  const participants = useMemo(() => {
    if(event.type === 'player')
      return event.players.sort((a, b) => a.lastname.localeCompare(b.lastname)).map(player => ({name : player.firstname[0] + '.' + player.lastname, nationality : player.naitionality}))
    
    if(event.type === 'team')
      return event.teams.sort((a, b) => a.name.localeCompare(b.name)).map(team => ({name : team.name, nationality : team.nationality}))
  }, [event])

    return <ToggleParticipants  label={event.type === 'team' ? 'équipes' : 'athlètes'} participants={participants}/>

}

const ToggleParticipants = ({ label, participants }) => {
  const [showParticipants, setShowParticipants] = useState(false);

  const handleToggle = () => {
    setShowParticipants(!showParticipants);
  };

  if(!participants || !participants.length)
    return null

  return (
    <div>
      <Button
        endIcon={showParticipants ? <ExpandLess /> : <ExpandMore />}
        onClick={handleToggle}
        sx={{ 
          textTransform: 'none', 
          justifyContent: 'space-between', 
          width: '100%',
          height : '20px',
          bgcolor : '#E5E7E9',
          color : '#47464B',
          mb : 1
        }}
      >
        Afficher les {label}
      </Button>
      {showParticipants && (
        <List sx={{ width: '100%', bgcolor: '#F4F4F4', boxShadow : '4px 4px 10px rgb(200,200, 200)' }}>
          {participants.map((participant, index) => (
            <ListItem key={index} sx={{padding : 0, margin : 0}}>
              <ListItemText 
                sx={{margin : 0, textIndent : '3rem'}}
                primary={participant.name} 
                primaryTypographyProps={{
                  fontSize: '0.9rem',
                  color : '#47464B',
                  bgcolor : 'f2f2f2'
                }}
              />
            </ListItem>
          ))}
        </List>
      )}
    </div>
  );
};

export default SportEventList